import ExperienceDropDown from './ExperienceDropDown';
// import ExperinceChart from './ExperinceChart';
import Projects from './Projects';
import Introduction from './Introduction';
import Skills from './Skills';
import EndNote from './EndNote';
import HoverButton from './HoverButton';
import { HeroSection } from './Components/Hero';
import TechSection from './Components/TechSection';
import ExperienceTimeline from './Experience/ExperienceTimeLine';

function App() {
  return (
    <div>
      <HeroSection />
      <TechSection />
      {/* <HoverButton /> */}
      {/* <Introduction /> */}
      {/* <Skills /> */}
      {/* <ExperinceChart /> */}
      <Projects />
      {/* <ExperienceDropDown /> */}
      <ExperienceTimeline />
      <EndNote />
    </div>
  );
}

export default App;
